import React from 'react';
import { Box, Card, Chip, Container, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StoreIcon from '@mui/icons-material/Store';

import visaLogo from '../../../../assets/visaLogo.png';
import masterLogo from '../../../../assets/masterLogo.png';
import amexLogo from '../../../../assets/amexLogo.png';
import multiRed from '../../../../assets/multired-logo.jpg';

import {
	benefitRowSx,
	logoBoxSx,
	logoGridSx,
	paymentCardSx,
	paymentIntroSx,
	paymentMethodChipSx,
	paymentSectionTitleSx,
} from './sharedStyles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
			paddingTop: theme.spacing(2),
			maxWidth: '100%',
		},
		paymentMethodsGrid: {
			display: 'flex',
			flexWrap: 'wrap',
			gap: theme.spacing(1),
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		paymentIcon: {
			marginRight: theme.spacing(0.5),
			color: theme.palette.secondary.main,
		},
		multiRedLogo: {
			maxWidth: '44px',
			borderRadius: 6,
			flex: '0 0 auto',
		},
	}),
);

interface MevueloBOPaymentMethodsProps {
	isExternal?: boolean;
}

const MevueloBOPaymentMethods = ({ isExternal }: MevueloBOPaymentMethodsProps): JSX.Element => {
	const classes = useStyles();

	const paymentMethods = [
		{
			label: 'Transferencia bancaria',
			icon: <AccountBalanceWalletIcon className={classes.paymentIcon} fontSize="small" />,
		},
		{
			label: 'Tarjetas de crédito y débito',
			icon: <CreditCardIcon className={classes.paymentIcon} fontSize="small" />,
		},
		{ label: 'Pago en el local', icon: <StoreIcon className={classes.paymentIcon} fontSize="small" /> },
		{ label: 'Redes de cobranza', icon: <AccountBalanceIcon className={classes.paymentIcon} fontSize="small" /> },
	];

	return (
		<div className={classes.root}>
			<Container component="main" maxWidth="md">
				<Typography component="h1" variant="h6" sx={paymentSectionTitleSx(isExternal)}>
					Nuestras formas de pago:
				</Typography>
				<Typography variant="body2" color="text.secondary" fontWeight={500} sx={paymentIntroSx}>
					Elegí la forma de pago que mejor se adapte a tu viaje.
				</Typography>
				<Card sx={paymentCardSx}>
					<Typography variant="body2" fontWeight={800} color="primary">
						Medios disponibles
					</Typography>
					<Box className={classes.paymentMethodsGrid}>
						{paymentMethods.map((method) => (
							<Chip key={method.label} icon={method.icon} label={method.label} size="small" sx={paymentMethodChipSx} />
						))}
					</Box>
					<Typography variant="body2" fontWeight={800} color="primary" mt={1.5}>
						Tarjetas
					</Typography>
					{/* Solo los sellos de tarjetas: Red Enlace salió de la grilla y Multi Red
					    quedó como fila discreta abajo (pedido de Sebastian, 2026-08-06). */}
					<Box sx={logoGridSx}>
						<Box sx={logoBoxSx}>
							<img src={visaLogo} alt="visa" />
						</Box>
						<Box sx={logoBoxSx}>
							<img src={amexLogo} alt="american-express" />
						</Box>
						<Box sx={logoBoxSx}>
							<img src={masterLogo} alt="master-card" />
						</Box>
					</Box>
					<Box sx={{ ...benefitRowSx, justifyContent: 'flex-start', marginTop: '14px' }}>
						<img src={multiRed} alt="Multi Red" className={classes.multiRedLogo} />
						<Typography variant="body2" color="text.secondary" sx={{ minWidth: 0 }}>
							También podés pagar en cualquier punto Multi Red de todo el país.
						</Typography>
					</Box>
				</Card>
			</Container>
		</div>
	);
};
export default MevueloBOPaymentMethods;
